/**
 * Pickentory Cart Restore
 * 
 * Saves cart contents to localStorage before checkout so customers
 * can restore their cart if they come back without completing payment.
 * 
 * Injected into the cart drawer via snippets/cart-drawer.liquid.
 */
(function () {
  'use strict';

  var STORAGE_KEY   = 'pkt_saved_cart';
  var CART_TTL_MS   = 1000 * 60 * 60 * 24 * 3; // 3 days
  var BANNER_ID     = 'pkt-restore-banner';

  // ── Save cart before checkout ──────────────────────────────────────────────
  function hookCheckoutButton() {
    function attachTo(btn) {
      if (!btn || btn._pktHooked) return;
      btn._pktHooked = true;
      btn.addEventListener('click', function () {
        saveCartNow();
      });
    }

    // Hook both the drawer and page checkout buttons
    ['CartDrawer-Checkout', 'checkout'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) attachTo(btn);
    });

    // Also catch any button[name=checkout] in a cart form
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(attachTo);
  }

  function saveCartNow() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        var saved = {
          saved_at: Date.now(),
          items: cart.items.map(function (item) {
            return {
              variant_id:  item.variant_id,
              quantity:    item.quantity,
              properties:  item.properties || {},
              product_title: item.product_title,
              variant_title: item.variant_title,
              image:         item.image,
            };
          }),
        };

        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
        } catch (e) {}
      })
      .catch(function () {});
  }

  // ── On load: check if cart is empty + saved cart exists ───────────────────
  function maybeShowRestoreBanner() {
    var raw;
    try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { return; }
    if (!raw) return;

    var saved;
    try { saved = JSON.parse(raw); } catch (e) { return; }
    if (!saved || !saved.items || !saved.items.length) return;

    // Expired?
    if (Date.now() - (saved.saved_at || 0) > CART_TTL_MS) {
      clearSaved();
      return;
    }

    // Check if current cart is empty
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          // Cart already has items — clear saved so we don't re-offer later
          clearSaved();
          return;
        }
        showBanner(saved);
      })
      .catch(function () {});
  }

  function showBanner(saved) {
    if (document.getElementById(BANNER_ID)) return;

    // Build item summary
    var summary = saved.items.slice(0, 3).map(function (it) {
      var name = it.product_title || 'Item';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? ' — ' + it.variant_title : '';
      // Find design thumbnail
      var thumb = it.image || '';
      var props = it.properties || {};
      if (props['_design_url'])   thumb = props['_design_url'];
      if (props['_design_proof']) thumb = props['_design_proof'];

      return '<div style="display:flex;align-items:center;gap:10px;padding:6px 0;border-bottom:1px solid rgba(0,0,0,.06)">'
        + (thumb ? '<img src="' + thumb + '" style="width:44px;height:44px;object-fit:contain;border-radius:6px;border:1px solid #e5e7eb;flex-shrink:0" loading="lazy">' : '')
        + '<div style="font-size:13px;line-height:1.4">'
        + '<div style="font-weight:600">' + name + '</div>'
        + (variant ? '<div style="color:#6b7280">' + variant + '</div>' : '')
        + '<div style="color:#6b7280">Qty: ' + it.quantity + '</div>'
        + '</div></div>';
    }).join('');

    var moreCount = saved.items.length - 3;
    if (moreCount > 0) {
      summary += '<div style="font-size:12px;color:#6b7280;padding-top:4px">+ ' + moreCount + ' more item' + (moreCount > 1 ? 's' : '') + '</div>';
    }

    var banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.style.cssText = [
      'position:fixed',
      'bottom:20px',
      'left:50%',
      'transform:translateX(-50%)',
      'z-index:9999998',
      'background:#fff',
      'border:1px solid #e5e7eb',
      'border-radius:16px',
      'box-shadow:0 8px 32px rgba(0,0,0,.14)',
      'padding:18px 20px',
      'max-width:360px',
      'width:calc(100vw - 32px)',
      'font-family:inherit',
    ].join(';');

    banner.innerHTML = ''
      + '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:10px">'
      +   '<div style="font-size:15px;font-weight:700;color:#111">You left something behind</div>'
      +   '<button id="pkt-restore-dismiss" style="background:none;border:none;cursor:pointer;font-size:18px;color:#9ca3af;line-height:1;padding:0;flex-shrink:0" aria-label="Dismiss">&times;</button>'
      + '</div>'
      + '<div style="margin-bottom:12px">' + summary + '</div>'
      + '<div style="display:flex;gap:8px">'
      +   '<button id="pkt-restore-yes" style="flex:1;background:#111;color:#fff;border:none;border-radius:8px;padding:10px 0;font-size:14px;font-weight:600;cursor:pointer">Restore cart</button>'
      +   '<button id="pkt-restore-no"  style="flex:1;background:#f3f4f6;color:#374151;border:none;border-radius:8px;padding:10px 0;font-size:14px;font-weight:600;cursor:pointer">No thanks</button>'
      + '</div>';

    document.body.appendChild(banner);

    document.getElementById('pkt-restore-yes').addEventListener('click', function () {
      restoreCart(saved);
    });
    document.getElementById('pkt-restore-no').addEventListener('click', function () {
      clearSaved();
      banner.remove();
    });
    document.getElementById('pkt-restore-dismiss').addEventListener('click', function () {
      banner.remove(); // don't clear — ask again next visit
    });
  }

  function restoreCart(saved) {
    var banner = document.getElementById(BANNER_ID);
    var btn = document.getElementById('pkt-restore-yes');
    if (btn) { btn.textContent = 'Restoring…'; btn.disabled = true; }

    var items = saved.items.map(function (it) {
      return {
        id:         it.variant_id,
        quantity:   it.quantity,
        properties: it.properties || {},
      };
    });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: items }),
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart API error ' + r.status);
      return r.json();
    })
    .then(function () {
      clearSaved();
      if (banner) banner.remove();
      // Trigger theme cart refresh
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      // If no cart drawer, reload page to show updated cart
      setTimeout(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.open) return;
        // Try to open cart drawer
        var drawerBtn = document.querySelector('[aria-controls="CartDrawer"]');
        if (drawerBtn) {
          drawerBtn.click();
        } else {
          window.location.reload();
        }
      }, 300);
    })
    .catch(function (err) {
      if (btn) { btn.textContent = 'Failed — try again'; btn.disabled = false; }
      console.error('[Pickentory] Cart restore failed:', err);
    });
  }

  function clearSaved() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    hookCheckoutButton();
    // Small delay so cart.js fetch reflects actual cart state
    setTimeout(maybeShowRestoreBanner, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-hook after cart drawer updates (Dawn uses custom elements that re-render)
  document.addEventListener('cart:refresh', function () {
    setTimeout(hookCheckoutButton, 500);
  });
})();
